$(function() {
    $('.header-links ul li a').mouseover(function() {
        var spanWidth = $(this).find('span').innerWidth() + (25 + 15);

        $(this).width(spanWidth);

    }).mouseout(function() {
        $(this).innerWidth(50);
    });
});